import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalCard = styled(Card)({
	width: '100%',
	maxWidth: '460px',
	padding: '39px 32px 32px',
	margin: 'auto',
});
